import React from "react";
import { YhBox } from "@/components/YhBox";
import flowImg from "@/assets/images/flow1.png";
import flowImg2 from "@/assets/images/flow3.jpg";
import flowImg2En from "@/assets/images/flow3En.jpg";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function Left() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale,language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    return (
        <YhBox
            title={Locale["Functional distribution diagram"]}
            width="45%"
            style={{ height: "calc(100vh - 148px)",  marginBottom: 0, verticalAlign: 'top' }}
            contentClass="pt-40 overflow-y-auto h-100"
        >
            <div className="home-left-box"><img src={language=="zh-CN"?flowImg2:flowImg2En} alt="" /></div>
        </YhBox>
    )
} 